import * as React from 'react'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import PropTypes from 'prop-types'
export function StepsNavigation({ sx, previousStepCompleted, steps, activeStep, handleBack, handleComplete, handleNext, handleReset }) {
  const baseSx = {
    display: 'flex',
    flexDirection: 'row',
    pt: { xs: 0, sm: 1 },
    marginBottom: { xs: 0, sm: 1 }
  }
  return (
    <Box sx={[baseSx, sx]}>
      <Button variant='text' disabled={activeStep === 0} startIcon={<KeyboardDoubleArrowLeftIcon />} onClick={handleBack} sx={{ mr: 1 }}>
        Précédent
      </Button>
      <Box sx={{ flex: '1 1 auto' }} />

      {activeStep === steps.length - 1 ? (
        <Button variant='outlined' onClick={handleComplete} disabled={!previousStepCompleted}>
          Terminer
        </Button>
      ) : (
        <Button
          variant='text'
          onClick={handleNext}
          sx={{ mr: 1 }}
          disabled={!previousStepCompleted}
          endIcon={<KeyboardDoubleArrowRightIcon />}
        >
          Suivant
        </Button>
      )}
      {activeStep !== 0 && <Button onClick={handleReset}>Annuler</Button>}
    </Box>
  )
}

StepsNavigation.propTypes = {
  previousStepCompleted: PropTypes.bool.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleComplete: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  sx: PropTypes.object
}
